const initialState = {
	proc: null,
    uo: null,
    step: null,
	paraCd: null,
    subtype: "IN"
}

export default function userReducer(state = initialState, action) {
	switch (action.type) {
		case 'setMaster': {
			return {
				...state,
				proc: action.proc === undefined ?  state.proc : action.proc,
				uo: action.uo === undefined ?  state.uo : action.uo,
				step: action.step === undefined ?  state.step : action.step,
				paraCd: null
			}
		}
		case 'setMasterSubType': {
			return {
				...state,
				subtype: action.subtype,
				paraCd: null
			}
		}
		case 'setMasterParaCd': {
			return {
				...state,
				paraCd: action.paraCd
			}
		}
		case 'getMaster': {
			return {
				...state
			}
		}
		default:
			return state
	}
}